import { loadRemoteModule } from '@cw-elements/mfe-setup/load';
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Button, ButtonType } from 'syngenta-digital-cropwise-react-ui-kit';

interface MachineryUploadProps {
  userLanguage: string;
  orgId: string;
  userId: string;
  isOpen: boolean;
  toOpen: string;
  onClose: () => void;
}

interface MachineryUploadWrapperProps {
  orgId: string;
  userId: string;
}

export const MachineryUpload: React.FC<MachineryUploadWrapperProps> = ({ orgId, userId }) => {
  const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);

  const MachineryUploadComponent = React.useMemo(
    () =>
      React.lazy<React.FC<MachineryUploadProps>>(() =>
        loadRemoteModule('connect-files/connect-files-management'),
      ),
    [],
  );

  return (
    <div className="gap-8 flex flex-col items-center justify-center">
      <Button type={ButtonType.primary} onClick={() => setIsModalOpen(true)}>
        Open Machinery upload
      </Button>
      <ErrorBoundary fallback={<span />}>
        <React.Suspense fallback={<span />}>
          <MachineryUploadComponent
            userLanguage="en"
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            toOpen="machinery-upload"
            orgId={orgId}
            userId={userId}
          />
        </React.Suspense>
      </ErrorBoundary>
    </div>
  );
};
